import * as React from 'react'
import PropTypes from 'prop-types'
import { useProfile } from 'context/ProfileProvider'
import Page403 from 'components/Page403'
import Spinner from 'components/Spinner'

function PrivateRoute({ permissions, children }) {
  const { profile, hasPermission } = useProfile()

  function hasPermissions() {
    if (!permissions.length) return true
    return permissions.some(permission => hasPermission(permission))
  }

  // Permissions are not fetched yet
  if (!profile?.permissions) return <Spinner />

  // Permissions OK
  if (hasPermissions()) return children

  // No permissions: 403
  return <Page403 />
}

PrivateRoute.defaultProps = {
  permissions: [],
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permissions: PropTypes.array,
}

export default PrivateRoute
